import React, { FC, useCallback, useState } from 'react';

import { LIST_PAGE_SIZE } from 'utils/constants';
import { resqlExpertAdminApi } from 'utils/api/resqlexpert';
import { usePaginatedOptions } from 'utils/usePaginatedOptions';
import useAutoSelect from 'utils/useAutoSelect';
import { AdminSubmissionFilters, ResqlExpertSubmissionListItem } from 'utils/api/resqlexpert.d';
import { ResqlExpertStyled } from 'components/ResqlExpert/styles';

import Submission from './Submission';
import ExpertList from './SubmissionsList';

const Expert: FC = () => {
  const [filters, setFilters] = useState<AdminSubmissionFilters>({});
  const [selectedId, setSelectedId] = useState<number | undefined>(undefined);

  const fetchSubmissions = useCallback(
    ({ name, page, size, signal }: { name?: string; page: number; size: number; signal?: AbortSignal }) =>
      resqlExpertAdminApi.listAdmin({ query: name, filters, page, size, signal }),
    [filters],
  );

  const list = usePaginatedOptions<ResqlExpertSubmissionListItem>({
    fetch: fetchSubmissions,
    pageSize: LIST_PAGE_SIZE,
  });

  useAutoSelect(list.options, selectedId, setSelectedId);

  return (
    <ResqlExpertStyled>
      <ExpertList
        items={list.options}
        hasMore={list.hasMore}
        loading={list.loading}
        error={list.error}
        loadMore={list.loadMore}
        retry={list.retry}
        selectedId={selectedId}
        setSelectedId={setSelectedId}
        query={list.search}
        setQuery={list.setSearch}
        filters={filters}
        setFilters={setFilters}
      />
      <Submission id={selectedId} fetchData={list.refresh} />
    </ResqlExpertStyled>
  );
};

export default Expert;
